<template>
    <div class="doc_sb_edit p-3">
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_type">
                Тип
            </label>
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-typewriter fs-xl"></i>
                    </span>
                </div>
                <input id="advanced_type" disabled type="text" class="form-control" :value="typeLabel">
            </div>
        </div>
        
        <div class="form-group mt-2" v-if="has_action">
            <label class="form-label" for="advanced_state">
                Статус
            </label>
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-typewriter fs-xl"></i>
                    </span>
                </div>
                <input id="advanced_state" disabled type="text" class="form-control" :value="stateLabel">
            </div>
        </div>
        
        <div class="form-group mt-2">
            <label class="form-label" for="advanced_created">
                Створено
            </label>
            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal fa-typewriter fs-xl"></i>
                    </span>
                </div>
                <input id="advanced_created" disabled type="text" class="form-control" :value="createdAtLabel">
            </div>
        </div>
        
        <div class="list_state mt-4">
            <h5 class="mb-3">Відповіді</h5>
            
            <div v-if="doc.answers_view && doc.answers_view.length">
                <div
                    v-for="item in doc.answers_view"
                    :key="item.id"
                    class="card mb-3 shadow-0 border"
                    :class="answerRiskClass(item)"
                >
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start flex-wrap">
                            <div class="pr-3">
                                <h6 class="mb-1">
                                    {{ item.title }}
                                </h6>
                                
                                <div v-if="item.description" class="text-muted small mb-2">
                                    {{ item.description }}
                                </div>
                                
                                <div v-if="item.group_title" class="small text-info mb-2">
                                    {{ item.group_title }}
                                </div>
                            </div>
                            
                            <span
                                class="badge"
                                :class="item.answer ? 'badge-success' : 'badge-secondary'"
                            >
                                {{ item.answer_text }}
                            </span>
                        </div>
                        
                        <div v-if="item.comment" class="mt-3">
                            <label class="form-label mb-1">Коментар</label>
                            <div class="alert alert-light border mb-0" style="white-space: pre-line;">
                                {{ item.comment }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-else class="text-muted">
                Немає відповідей
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "doc_general",
    props: {
        doc: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        answerRiskClass(item) {
            if (!this.has_action) {
                return '';
            }
            
            if (item.risk_state === 'red') {
                return 'risk-card risk-card--red';
            }
            
            if (item.risk_state === 'yellow') {
                return 'risk-card risk-card--yellow';
            }
            
            return '';
        }
    },
    computed: {
        
        svk() {
            return this.doc.svk || {
                "has_action": false,
            };
        },
        
        has_action() {
            return this.svk.has_action;
        },
        
        typeLabel() {
            if (this.doc.type === 'year') return 'Щорічна';
            if (this.doc.type === 'ad-hoc') return 'Ситуативна (Ad-hoc)';
            return this.doc.type || '';
        },
        
        stateLabel() {
            if (this.doc.state === 'green') return 'Зелений';
            if (this.doc.state === 'yellow') return 'Жовтий';
            if (this.doc.state === 'red') return 'Червоний';
            return this.doc.state || '';
        },
        
        createdAtLabel() {
            if (!this.doc.created_at) {
                return '';
            }
            
            return new Date(this.doc.created_at).toLocaleString('uk-UA');
        },
        
    }
}
</script>

<style scoped>
.risk-card {
    transition: all 0.2s ease;
}

.risk-card--yellow {
    border: 1px solid #f4d03f !important;
    background: #fffbea;
}

.risk-card--red {
    border: 1px solid #e74c3c !important;
    background: #fff1f0;
}
</style>